import { useEffect, useRef } from "react";
import { Card, ListGroup, Alert } from "react-bootstrap";

interface RazorpayButtonPageProps {
    paymentButtonId: string;
}

const medicineData = [
    {
        name: "Mounjaro 2.5 Mg",
        dosage: "2.5mg × 4 doses per month",
        cost: "₹12,000",
        buttonId: "pl_RAcqrNPmRVxbl0",
        details:
            "Dual GIP/GLP-1 receptor agonist for type 2 diabetes, supplied by distributor. For reference only.",
    },
];

export function RazorpayButtonPage({
    paymentButtonId,
}: RazorpayButtonPageProps) {
    const formRef = useRef<HTMLFormElement>(null);

    // Find medicine details by button ID
    const medicine = medicineData.find((m) => m.buttonId === paymentButtonId);

    useEffect(() => {
        if (!paymentButtonId || !formRef.current) return;
        // Remove any existing script
        const prevScript = document.getElementById("razorpay-btn-script");
        if (prevScript) prevScript.remove();

        // Remove any existing payment button form children
        while (formRef.current.firstChild) {
            formRef.current.removeChild(formRef.current.firstChild);
        }

        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/payment-button.js";
        script.async = true;
        script.id = "razorpay-btn-script";
        script.setAttribute("data-payment_button_id", paymentButtonId);
        formRef.current.appendChild(script);
    }, [paymentButtonId]);

    if (!paymentButtonId) {
        return (
            <Alert variant="danger" className="text-center mt-5">
                Missing payment_button_id in URL
            </Alert>
        );
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: 48,
                width: "100%",
                justifyContent: "center",
            }}
        >
            {medicine ? (
                <Card
                    style={{
                        maxWidth: 460,
                        width: "100%",
                        marginBottom: 32,
                        borderRadius: 20,
                        overflow: "hidden",
                        boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {/* Header strip with medicine name */}
                    <div
                        style={{
                            background:
                                "linear-gradient(90deg, #1841bdff, #0d5ec2ff)",
                            padding: "16px 20px",
                            color: "white",
                            width: "100%",
                            textAlign: "center",
                        }}
                    >
                        <h4 style={{ margin: 0, fontWeight: 600 }}>
                            {medicine.name}
                        </h4>
                    </div>

                    <Card.Body
                        style={{
                            padding: "20px 24px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                        }}
                    >
                        {/* Details */}
                        <Card.Text
                            className="mb-3"
                            style={{
                                fontSize: 15,
                                color: "#495057",
                                textAlign: "center",
                            }}
                        >
                            {medicine.details}
                        </Card.Text>

                        {/* Pack / Dosage Info (non-prescriptive) */}
                        <ListGroup
                            variant="flush"
                            className="mb-3"
                            style={{ width: "100%", textAlign: "center" }}
                        >
                            <ListGroup.Item
                                style={{
                                    border: "none",
                                    paddingLeft: 0,
                                    textAlign: "center",
                                }}
                            >
                                <strong>
                                    📦 Medication will be fulfilled and invoiced
                                    by Medineedz Medicals
                                </strong>
                            </ListGroup.Item>
                        </ListGroup>

                        {/* Cost */}
                        <div style={{ width: "100%", textAlign: "center" }}>
                            <div
                                style={{
                                    fontWeight: 500,
                                    color: "#495057",
                                    marginBottom: 4,
                                }}
                            >
                                Price Per Month (4 doses)
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <span
                                    style={{
                                        background: "#e9f7ef",
                                        color: "#0b33a1ff",
                                        fontWeight: 600,
                                        borderRadius: 30,
                                        padding: "6px 18px",
                                        fontSize: 16,
                                        display: "inline-block",
                                    }}
                                >
                                    {medicine.cost}
                                </span>
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                marginTop: 16,
                            }}
                        >
                            <form ref={formRef} />
                        </div>
                    </Card.Body>
                </Card>
            ) : (
                <Alert
                    variant="warning"
                    className="mb-4"
                    style={{
                        maxWidth: 420,
                        width: "100%",
                        textAlign: "center",
                    }}
                >
                    Medicine details not found for this payment button.
                </Alert>
            )}
        </div>
    );
}
